var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "leaveGroupModal",
      staticClass: "modal fade",
      attrs: {
        id: "leaveGroupModal",
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": "leaveQuestionTitle",
        "aria-hidden": "true",
        "data-backdrop": "static",
        "data-keyboard": "false",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-dialog-centered",
          attrs: { role: "document" },
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c(
                "h5",
                {
                  staticClass: "modal-title",
                  attrs: { id: "exampleModalLongTitle" },
                },
                [_vm._v(_vm._s(_vm.__("globals.before_you_leave")))]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: { type: "button", "aria-label": "Close" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.close.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("span", { attrs: { "aria-hidden": "true" } }, [
                    _vm._v("×"),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("p", { staticClass: "text-left" }, [
                _vm._v(_vm._s(this.leave_question)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.user_response,
                      expression: "user_response",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { cols: "30", rows: "5" },
                  domProps: { value: _vm.user_response },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.user_response = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                this.errors.leave_response &&
                this.errors.leave_response.length > 0
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "text-left text-danger help-block font-small-1",
                        attrs: { role: "alert" },
                      },
                      [
                        _c("i", { staticClass: "feather icon-x-circle" }),
                        _vm._v(" "),
                        _vm._l(this.errors.leave_response, function (error) {
                          return [
                            _vm._v(
                              "\n                                " +
                                _vm._s(error) +
                                "\n                            "
                            ),
                          ]
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "text-success text-left" }),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex justify-content-end" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-sml btn-danger",
                    attrs: { id: "skip" },
                    on: {
                      click: function ($event) {
                        return _vm.skip()
                      },
                    },
                  },
                  [_vm._v("Skip")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-sml btn-success ml-05",
                    attrs: { id: "submit_response" },
                    on: {
                      click: function ($event) {
                        return _vm.storeResponse()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.__("globals.submit_response")))]
                ),
              ]),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }